import { render, staticRenderFns } from "./PropertyExamine2.vue?vue&type=template&id=22d1b4ce"
import script from "./PropertyExamine2.vue?vue&type=script&lang=js"
export * from "./PropertyExamine2.vue?vue&type=script&lang=js"
import style0 from "./PropertyExamine2.vue?vue&type=style&index=0&id=22d1b4ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports